import { jsx as _jsx } from "react/jsx-runtime";
import { useDroppable } from '@dnd-kit/core';
import { styled } from 'styled-components';
import { Box } from "../../../../box/src";
import { useDraggableList } from './DraggableListContext';
import { Row } from './Row';
const ListDroppableArea = ({ children }) => {
    const { setNodeRef: droppableRef } = useDroppable({
        id: `droppable-area`,
    });
    return _jsx(StyledRowList, { ref: droppableRef, children: children });
};
export const RowList = ({ RowComponent }) => {
    const { sortedIds } = useDraggableList();
    return (_jsx(ListDroppableArea, { children: sortedIds.map((dataId) => (_jsx(Row, { datumId: dataId, RowComponent: RowComponent }, dataId))) }));
};
const StyledRowList = styled(Box).attrs(() => ({
    flexDirection: 'column',
    width: '100%',
})) ``;
//# sourceMappingURL=RowList.js.map